import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTracking } from '../../tracking';
export function CTAClickTracking(props) {
    const { emitUserInteractionEvent } = useTracking();
    const handleClick = (event) => {
        const target = event.target;
        emitUserInteractionEvent({
            interaction_name: 'call_to_action',
            event_action: 'click',
            interaction_raw_text: target.innerText,
            destination_href: target.getAttribute('href') || '',
            option_selected: 'cta_button',
        });
    };
    return (_jsx("div", Object.assign({ role: "none", css: { display: 'flex', flexDirection: 'column' }, onClick: handleClick }, { children: props.children })));
}
//# sourceMappingURL=CTAClickTracking.js.map